export const ChevronDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.398 15.663a.56.56 0 0 1-.795 0L5.868 9.928a.56.56 0 0 1 0-.795l.265-.266c.22-.22.576-.22.796 0L12 13.94l5.071-5.072c.22-.22.576-.22.796 0l.265.266c.22.22.22.575 0 .795z"
        clipRule="evenodd"
      />
    </svg>
  );
};
